exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.case-table[data-v-06a934ca] th {\n    color: #000 !important;\n    background: var(--monitor-header);\n    border-right: 1px solid #fff;\n}\n.case-table[data-v-06a934ca] td:not(:last-child) {\n    border-right: 1px solid var(--white-border);\n}\n", ""]);

